import { getDynamoDB } from '../../../../common/utils/DynamoDbUtils'
import { table } from '../../../../_constants/Code' // table が未インポートの場合

// "YYYY年M月期" を "YYYY年度" に変換する関数
const convertPeriodToFiscalYear = (periodLabel) => {
  const match = periodLabel.match(/^(\d{4})年(\d{1,2})月期$/)
  if (!match) {
    return '' // フォーマットが不正の場合は空文字を返す
  }

  let year = parseInt(match[1], 10)
  const month = parseInt(match[2], 10)

  // 月が12でなければ年度は1年減らす
  if (month !== 12) {
    year -= 1
  }

  return `${year}年度`
}

export async function parseStandardFormatSecondment(corporationNumber) {
  try {
    // 1. PeriodKind が 'year' の DataCreateTask レコードを取得する
    const dataCreateTasks = await getDynamoDB(
      table.DataCreateTask,
      null,
      corporationNumber,
      { CorporationNumber: corporationNumber },
      null
    )
    if (!dataCreateTasks || dataCreateTasks.length === 0) {
      return []
    }

    // 2. DataCreateTask のすべての Key のリストを取得する
    const keys = dataCreateTasks.filter((x) => x.PeriodKind === 'year').map((task) => String(task.Key))

    if (keys.length === 0) {
      return []
    }

    // 3. CorporationNumber に対応するすべての GenericUploadTask レコードを取得する
    const allGenericTasks = await getDynamoDB(
      table.GenericUploadTask,
      null,
      corporationNumber,
      { CorporationNumber: corporationNumber },
      null
    )

    // 4. SuperKey が keys の中にあり、かつ Status = 'registered' の GenericUploadTask レコードをフィルタリングする
    const registeredTasks = allGenericTasks.filter(
      (task) => keys.includes(String(task.SuperKey)) && task.Status === 'registered'
    )

    // 5. 登録済みの SuperKey のリストを取得する
    const registeredSuperKeys = new Set(registeredTasks.map((task) => String(task.SuperKey)))

    // 6. registeredSuperKeys 内の Key を持つ DataCreateTask を再取得し、PeriodValue を得る
    const registeredDataCreateTasks = dataCreateTasks.filter((task) => registeredSuperKeys.has(String(task.Key)))

    // 7. 一意な PeriodValue を取得し、年度形式（年度）に変換する
    const periodValueSet = new Set()
    registeredDataCreateTasks.forEach((task) => {
      if (task.PeriodValue) {
        const fiscalYear = convertPeriodToFiscalYear(task.PeriodValue)
        if (fiscalYear) {
          periodValueSet.add(fiscalYear)
        }
      }
    })
    const resultArray = Array.from(periodValueSet).sort()
    // 8. 変換およびソートされた PeriodValue のリストを返す
    return Array.from(periodValueSet).sort()
  } catch (error) {
    console.error('parseStandardFormatSecondment エラー:', error)
    return []
  }
}
